console.log("aaa")

function handleHeaderTransparency(){
    console.log("aa")
    var headerWrapper = document.querySelector('.header-wrapper');
    var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollPosition > 5) {
        headerWrapper.style.background = 'rgba(0, 0, 0, 0.2)';
      
    } else {
        headerWrapper.style.background = 'transparent';
    }
}
document.addEventListener('DOMContentLoaded', function () {
    window.addEventListener('scroll', handleHeaderTransparency);
});